<template>
  <div>
    <SOSlotBase :is-search="search.onSearch" :bg-grey="true" :container-name="'list-transaksi-snapclean-content'">
      <template v-slot:loading-page>
        <SOLoadingPage />
      </template>

      <template v-slot:title-bar v-if="isMinExport || !isExporting">
        <SOTitleBar
          :page-title="'Penghapusan Transaksi SnapClean'"
          :type="'back'"
          :show-search="true"
          @search="onOpenSearch"
          @back="back"
          v-if="!search.onSearch"
        />
      </template>

      <template v-slot:search-bar v-if="!isExporting">
        <SOSearchBar
          v-if="search.onSearch"
          :context="'Transaksi'"
          :placeholder="`Ketik minimal 2 karakter`"
          :value="search.key"
          :data-count="totalData"
          :search-information="`Nomor nota, Nama konsumen, Nama karyawan, Nama outlet`"
          :waiting="searching"
          @do-search="onSearch"
          @loading="onLoadingSearch"
          @close="onCloseSearch"
        />
      </template>

      <template v-slot:empty-state>
        <SOEmptyState
          v-if="!isNotEmpty && !isFetching && !search.onSearch"
          :message="'Tidak Ada Data Penghapusan'"
          :subMessage="'Penghapusan & permintaan hapus nota akan tampil disini'"
        />
        <SOEmptySearchState
          v-if="!isNotEmpty && !isFetching && search.onSearch && search.key.length > 1"
          @action="resetSearchFilter"
        />
      </template>

      <template v-slot:skeleton v-if="isFetching && !isLoadMore">
        <div class="p-x-20 p-y-16 w-limit">
          <SOCardTransaksiSkeleton v-if="!search.onSearch" />
          <SOLoadSearch v-if="search.onSearch" />
        </div>
      </template>

      <template v-slot:content>
        <div v-if="isNotEmpty && (isMinExport || !isExporting)">
          <SOExportProgressMinimized
            v-if="isMinExport"
            :processed-data="expProgress.processed"
            :total-data="expProgress.total"
            :context="'Transaksi SnapClean'"
            :tracker-actions="`${modulName}/exportTracker`"
            @on-success="checkExport"
            @on-error="exportFail"
          />
          <SOExportMultipleFile
            v-if="isMultipleExport"
            :export-data="exportData"
            :export-data-length="exportDataLength"
            :delete-cluster-actions="`${modulName}/exportDeleteCluster`"
            :delete-master-actions="`${modulName}/exportDeleteMaster`"
            @done="finishExport"
          />
        </div>
        <div class="p-x-20 w-limit" v-if="isMinExport || !isExporting">
          <div class="card_breadcrum p-t-16" v-if="(isNotEmpty || !search.onSearch) && !isFetching">
            <SOHeaderList :title="`${totalData} Penghapusan`" :show-filter="true" @filter="onOpenFilter" />
          </div>
          <div v-if="isNotEmpty">
            <SOCardItem
              v-for="(transaksi, idx) in listTransaksi"
              :key="`card-item${transaksi.idtransaksi}${idx}`"
              :data="transaksi"
            />
          </div>
          <div v-if="!isFetching && !isLoadMore && isNotEmpty">
            <SOFABExport @export="openModalExport" />
          </div>
          <SOLoadMoreLoading :id="'load-more-transaksi'" :loading="isLoadMore" />
        </div>
      </template>
      <template v-slot:export-import>
        <div class="vh-100" v-if="isExporting && !isMinExport">
          <SOExportProgress
            :context="'Transaksi SnapClean'"
            :tracker-actions="`${modulName}/exportTracker`"
            @on-success="checkExport"
            @on-error="exportFail"
            @minimized-export="minimizedExport"
          />
        </div>
      </template>
      <template v-slot:filter>
        <SOFilter
          v-if="onFilter"
          :filterPenghapusanTransaksi="{ snapclean: onFilter }"
          :sorting="sorting"
          @back="onCloseFilter"
          @do-filter="doFilter"
          @reset-filter="resetFilter"
        />
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOLoadSearch from "@/so-components/global/ui/SOLoadSearch";
import SOExportMultipleFile from "@/so-components/global/ui/SOExportMultipleFile";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOSearchBar from "@/so-components/global/ui/SOSearchBar";
import SOCardTransaksiSkeleton from "@/so-components/modules/transaksi/reguler/SOCardTransaksiSkeleton";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import SOCardItem from "../components/SOCardItem.vue";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SOEmptySearchState from "@/so-components/global/ui/SOEmptySearchState";
import SOFABExport from "@/so-components/global/ui/SOFABExport";
import SOExportProgress from "@/so-components/global/ui/SOExportProgress";
import SOExportProgressMinimized from "@/so-components/global/ui/SOExportProgressMinimized";

import SOFilter from "@/so-components/global/filter/base/SOFilter";

import { moduleName } from "../store/state";

export default {
  name: "Transaksi",
  components: {
    SOSlotBase,
    SOLoadingPage,
    SOTitleBar,
    SOSearchBar,
    SOLoadMoreLoading,
    SOCardTransaksiSkeleton,
    SOHeaderList,
    SOCardItem,
    SOLoadSearch,
    SOEmptyState,
    SOEmptySearchState,
    SOFABExport,
    SOExportProgress,
    SOExportProgressMinimized,
    SOFilter,
    SOExportMultipleFile,
  },
  data() {
    return {
      searching: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.toggleSearch(false);
      if (vm.search.key) {
        vm.toggleSearch(true);
      }
    });
  },
  mounted() {
    if (this.totalData <= 0) {
      this.init();
    }
    this.scroll();
  },
  watch: {
    getResponse: function(newRes, oldRes) {
      this.searching = false;
      if (newRes.success) {
        if (this.useToastSuccess && newRes.msg && newRes.msg !== oldRes.msg) {
          this.$toast.success(newRes.msg);
        }
      } else {
        if (newRes.err && newRes.err !== oldRes.err) {
          this.$toast.error(newRes.err);
        }
      }
    },
  },
  computed: {
    ...mapGetters(moduleName, {
      listTransaksi: "listTransaksi",
      isFetching: "isFecthing",
      isLoadMore: "isLoadMore",
      pagination: "pagination",
      sorting: "getSorting",
      search: "search",
      onFilter: "onFilter",
      getResponse: "getResponse",
      totalData: "totalData",
      isExporting: "exporting",
      isMinExport: "minExport",
      expProgress: "expProgress",
      useToastSuccess: "toastSuccess",
      isMultipleExport: "multipleExport",
      exportData: "exportData",
      exportDataLength: "exportDataLength",
    }),
    modulName() {
      return moduleName;
    },
    isNotEmpty() {
      return this.$store.getters[`${moduleName}/totalData`] > 0 ? true : false;
    },
  },
  methods: {
    ...mapActions({
      togleFilter: `${moduleName}/togleFilter`,
      toggleSearch: `${moduleName}/toggleSearch`,
      setSearchKey: `${moduleName}/setSearchKey`,
      resetSearchKey: `${moduleName}/resetSearchKey`,
      resetResponse: `${moduleName}/resetResponse`,
      resetPagination: `${moduleName}/resetPagination`,
      loadListTransaksi: `${moduleName}/loadListTransaksi`,
      resetListTransaksi: `${moduleName}/resetListTransaksi`,
      resetTotalData: `${moduleName}/resetTotalData`,
      toggleExporting: `${moduleName}/toggleExporting`,
      minimized: `${moduleName}/minimizedExport`,
      exportProgress: `${moduleName}/exportProgress`,
      exportTracker: `${moduleName}/exportTracker`,
      setExportData: `${moduleName}/setExportData`,
      setExportDataLength: `${moduleName}/setExportDataLength`,
      multipleExport: `${moduleName}/multipleExport`,
    }),
    async init() {
      await this.resetSearchKey();
      await this.resetResponse();
      await this.resetFilter();
      await this.resetDataList();

      await this.loadTransaksi();
    },
    back() {
      this.$router.push({
        name: "TransaksiDanPenghapusan",
      });

      this.resetDataList();
    },
    resetDataList() {
      this.resetPagination();
      this.resetListTransaksi();
      this.resetTotalData();
    },
    loadTransaksi() {
      this.loadListTransaksi();
    },
    onOpenSearch() {
      this.toggleSearch(true);
      this.resetFilter();
      this.resetDataList();
    },
    async onCloseSearch() {
      await this.toggleSearch(false);
      await this.init();
    },
    async onSearch(searchKey) {
      await this.resetDataList();
      await this.setSearchKey(searchKey);
      await this.loadTransaksi();
    },
    onLoadingSearch(value) {
      this.searching = value;
    },
    onOpenFilter() {
      this.togleFilter(true);
    },
    onCloseFilter() {
      this.togleFilter(false);
    },
    async scroll() {
      window.onscroll = async () => {
        if (!this.getResponse.success) {
          return;
        }

        let payload = {
          idLoadMore: "load-more-transaksi",
          container: "list-transaksi-snapclean-content",
          pagination: this.pagination,
          callback: this.loadTransaksi,
        };
        await this.$store.dispatch("helper/scroll", payload);
      };
    },
    openModalExport() {
      this.$router.push({ name: "PembatalanTransaksiSnapclean.export" });
    },
    finishExport() {
      this.multipleExport(false);
      this.setExportData([]);
    },
    async checkExport() {
      this.toggleExporting(false);
      this.minimized(false);
      this.multipleExport(false);

      let tracker = await this.exportTracker();
      if (!tracker.success) {
        return;
      }

      this.setExportDataLength(tracker.data.length);

      if (tracker.data.info_data_export.length > 0) {
        if (tracker.data.status === 1) {
          this.multipleExport(true);
          this.setExportData(tracker.data.info_data_export);
          if (this.exportData.length > 0) {
            this.exportData.forEach((v) => {
              v["downloaded"] = false;
            });
          }
        } else {
          this.minimized(true);
        }
      }
    },
    exportFail() {
      this.toggleExporting(false);
    },
    minimizedExport(data) {
      this.minimized(true);
      this.exportProgress(data);
    },
    async doFilter() {
      await this.resetPagination();
      await this.resetListTransaksi();
      await this.onCloseFilter();
      await this.loadTransaksi();
    },
    async resetFilter() {
      await this.$store.commit("filterGlobalModule/resetFilterItem");
      await this.$store.commit("filterGlobalModule/setFilter", JSON.parse(this.sorting[0].value));
    },
    resetSearchFilter() {
      this.resetFilter();
      this.resetSearchKey();
    },
  },
};
</script>
